/* ==========================================================================
   Les éditions Sésames : fiche produit 2026 (assets/sesames-product.js)
   Chargé en différé par sections/main-product.liquid.
   1. Informations détaillées : onglets à partir de 990 px (motif ARIA « tabs »,
      flèches, Début, Fin), accordéons <details> natifs en dessous.
   2. Liens internes vers un panneau (« Comment commander », « Livraison… ») :
      ouvrent le bon panneau puis y descendent.
   3. Changement de format : met à jour les éléments marqués data-s-maj
      (barre d'achat, fiche technique) à partir du rendu renvoyé à Sense.
   4. Barre d'achat collante sur mobile : visible dès que le bouton principal
      n'est pas à l'écran (au-dessus ou en dessous, donc dès l'arrivée) ; elle
      déclenche ce bouton. Sur une fiche à plusieurs formats, tant que les
      formats n'ont pas été vus, elle dit « Choisir le format » et y descend
      (audit du 13/10/2026, F1).
   5. Avis Judge.me : libellés restés en anglais ou au format américain, que
      l'offre gratuite de l'application ne permet pas de modifier (décision 45).
   6. Contenus numériques : ajout au panier bloqué tant que la case d'accord
      exprès n'est pas cochée (question 11).
   7. « Envoyer à un·e collègue » (bloc de partage de Sense) : le lien partagé
      porte ?utm_source=partage&utm_medium=collegue&utm_campaign=<handle>
      (audit du 13/10/2026, M7), y compris après un changement de format.
   Aucun appel réseau propre : tout passe par les scripts de Sense.
   ========================================================================== */
(function () {
  'use strict';

  var ECRAN_ONGLETS = '(min-width: 990px)';
  var ECRAN_MOBILE = '(max-width: 749px)';
  var mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');

  function defiler(element) {
    if (!element) return;
    element.scrollIntoView({ behavior: mouvementReduit.matches ? 'auto' : 'smooth', block: 'start' });
  }

  /* 1. Onglets et accordéons -------------------------------------------- */
  function Details(racine) {
    this.racine = racine;
    this.barre = racine.querySelector('.s-details__barre');
    this.onglets = Array.prototype.slice.call(racine.querySelectorAll('[role="tab"]'));
    this.panneaux = Array.prototype.slice.call(racine.querySelectorAll('.s-details__panneau'));
    this.actif = this.panneaux.length ? this.panneaux[0].id : null;
    this.mode = null;
    this.ecran = window.matchMedia(ECRAN_ONGLETS);
    var self = this;

    this.onglets.forEach(function (onglet) {
      onglet.addEventListener('click', function () {
        self.choisir(onglet.getAttribute('aria-controls'), false);
      });
    });
    if (this.barre) {
      this.barre.addEventListener('keydown', function (e) { self.clavier(e); });
    }
    var appliquer = function () { self.appliquer(); };
    if (this.ecran.addEventListener) this.ecran.addEventListener('change', appliquer);
    else if (this.ecran.addListener) this.ecran.addListener(appliquer);
    this.appliquer();
  }

  Details.prototype.appliquer = function () {
    var onglets = this.ecran.matches && this.onglets.length > 1;
    if (onglets === (this.mode === 'onglets')) return;
    this.mode = onglets ? 'onglets' : 'accordeons';
    var self = this;
    if (onglets) {
      this.racine.classList.add('s-details--onglets');
      if (this.barre) this.barre.hidden = false;
      this.panneaux.forEach(function (panneau) {
        var onglet = self.ongletDe(panneau.id);
        panneau.setAttribute('role', 'tabpanel');
        panneau.setAttribute('tabindex', '0');
        if (onglet) panneau.setAttribute('aria-labelledby', onglet.id);
        var resume = panneau.querySelector('summary');
        if (resume) resume.setAttribute('tabindex', '-1');
      });
      this.choisir(this.actif, true);
    } else {
      this.racine.classList.remove('s-details--onglets');
      if (this.barre) this.barre.hidden = true;
      this.panneaux.forEach(function (panneau, i) {
        panneau.removeAttribute('role');
        panneau.removeAttribute('tabindex');
        panneau.removeAttribute('aria-labelledby');
        panneau.hidden = false;
        panneau.open = self.actif ? panneau.id === self.actif : i === 0;
        var resume = panneau.querySelector('summary');
        if (resume) resume.removeAttribute('tabindex');
      });
    }
  };

  Details.prototype.ongletDe = function (idPanneau) {
    for (var i = 0; i < this.onglets.length; i++) {
      if (this.onglets[i].getAttribute('aria-controls') === idPanneau) return this.onglets[i];
    }
    return null;
  };

  Details.prototype.choisir = function (idPanneau, sansFocus) {
    var panneau = document.getElementById(idPanneau);
    if (!panneau || this.panneaux.indexOf(panneau) === -1) return;
    this.actif = idPanneau;
    if (this.mode !== 'onglets') {
      panneau.open = true;
      return;
    }
    this.panneaux.forEach(function (p) {
      p.open = true;
      p.hidden = p !== panneau;
    });
    this.onglets.forEach(function (o) {
      var choisi = o.getAttribute('aria-controls') === idPanneau;
      o.setAttribute('aria-selected', choisi ? 'true' : 'false');
      o.setAttribute('tabindex', choisi ? '0' : '-1');
      if (choisi && !sansFocus) o.focus();
    });
  };

  Details.prototype.clavier = function (e) {
    var i = this.onglets.indexOf(document.activeElement);
    if (i === -1) return;
    var cible = null;
    if (e.key === 'ArrowRight') cible = this.onglets[(i + 1) % this.onglets.length];
    else if (e.key === 'ArrowLeft') cible = this.onglets[(i - 1 + this.onglets.length) % this.onglets.length];
    else if (e.key === 'Home') cible = this.onglets[0];
    else if (e.key === 'End') cible = this.onglets[this.onglets.length - 1];
    if (!cible) return;
    e.preventDefault();
    this.choisir(cible.getAttribute('aria-controls'), false);
  };

  Details.prototype.ouvrir = function (idPanneau) {
    var panneau = document.getElementById(idPanneau);
    if (!panneau) return false;
    this.choisir(idPanneau, true);
    defiler(this.mode === 'onglets' ? this.racine : panneau);
    return true;
  };

  var instances = [];
  function initialiserDetails() {
    document.querySelectorAll('[data-s-details]').forEach(function (racine) {
      if (racine.dataset.sPret) return;
      racine.dataset.sPret = '1';
      instances.push(new Details(racine));
    });
  }

  /* 2. Liens internes vers un panneau ------------------------------------ */
  function ouvrirPanneau(idPanneau) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].panneaux.some(function (p) { return p.id === idPanneau; })) {
        return instances[i].ouvrir(idPanneau);
      }
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var lien = e.target.closest ? e.target.closest('a[href^="#s-panneau-"]') : null;
    if (!lien) return;
    var id = lien.getAttribute('href').slice(1);
    if (ouvrirPanneau(id)) {
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    }
  });

  /* 3. Changement de format ---------------------------------------------- */
  function surChangementDeFormat(evenement) {
    var donnees = evenement && evenement.data;
    if (!donnees || !donnees.html) return;
    document.querySelectorAll('[data-s-maj][id]').forEach(function (element) {
      var source = donnees.html.getElementById(element.id);
      if (source) element.innerHTML = source.innerHTML;
    });
    barres.forEach(function (barre) { barre.synchroniser(); });
    lienPartage();
  }

  /* 4. Barre d'achat collante (mobile) ----------------------------------- */
  var barres = [];
  function Barre(element) {
    this.element = element;
    this.section = element.dataset.section;
    this.bouton = element.querySelector('[data-s-barre-bouton]');
    this.principal = document.getElementById('ProductSubmitButton-' + this.section);
    this.formats = document.getElementById('variant-radios-' + this.section) ||
      document.querySelector('#MainProduct-' + this.section + ' .s-formats');
    this.libelleFormats = element.dataset.sLibelleFormats || 'Choisir le format';
    // « Choisir le format » seulement s'il y a un choix à faire et qu'il n'a pas déjà été fait :
    // une adresse avec ?variant= (Google Shopping, lien partagé) désigne déjà le format.
    this.formatsVus = !(element.dataset.sPlusieursFormats === 'true' && this.formats) ||
      /[?&]variant=/.test(window.location.search);
    this.ecran = window.matchMedia(ECRAN_MOBILE);
    this.horsEcran = false;
    var self = this;
    if (!this.principal || !this.bouton) return;

    this.bouton.addEventListener('click', function () {
      if (!self.formatsVus) {
        self.allerAuxFormats();
        return;
      }
      if (self.principal.disabled || self.principal.getAttribute('aria-disabled') === 'true') return;
      self.principal.click();
    });
    if (this.formats) {
      this.formats.addEventListener('change', function () { self.marquerVus(); });
    }

    // Positions relues au défilement (une fois par image) : la barre s'affiche dès que le bouton principal
    // n'est pas à l'écran, au-dessus comme en dessous, y compris après un saut (retour en haut, lien interne),
    // que l'observateur d'intersection ne signale pas toujours.
    var enAttente = false;
    var mesurer = function () {
      enAttente = false;
      var hauteur = window.innerHeight || document.documentElement.clientHeight;
      var bouton = self.principal.getBoundingClientRect();
      self.horsEcran = bouton.bottom < 0 || bouton.top > hauteur;
      if (!self.formatsVus && self.formats) {
        // Formats « vus » : au moins la moitié du bloc (ou 16 rem) visible au-dessus de la barre.
        var bloc = self.formats.getBoundingClientRect();
        var bas = hauteur - (self.element.hidden ? 0 : self.element.offsetHeight);
        var visible = Math.min(bloc.bottom, bas) - Math.max(bloc.top, 0);
        if (bloc.height > 0 && visible >= Math.min(bloc.height / 2, 160)) self.marquerVus();
      }
      self.afficher();
    };
    var planifier = function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(mesurer);
    };
    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    if (this.ecran.addEventListener) this.ecran.addEventListener('change', planifier);
    else if (this.ecran.addListener) this.ecran.addListener(planifier);
    this.synchroniser();
    planifier();
  }

  Barre.prototype.afficher = function () {
    var visible = this.horsEcran && this.ecran.matches;
    if (visible === !this.element.hidden) return;
    this.element.hidden = !visible;
    this.element.setAttribute('aria-hidden', visible ? 'false' : 'true');
    this.bouton.setAttribute('tabindex', visible ? '0' : '-1');
    document.body.classList.toggle('s-barre-achat-visible', visible);
  };

  Barre.prototype.marquerVus = function () {
    if (this.formatsVus) return;
    this.formatsVus = true;
    this.synchroniser();
  };

  Barre.prototype.allerAuxFormats = function () {
    if (!this.formats) return;
    this.formats.scrollIntoView({ behavior: mouvementReduit.matches ? 'auto' : 'smooth', block: 'center' });
    var champ = this.formats.querySelector('input:checked') || this.formats.querySelector('input, select');
    if (champ) champ.focus({ preventScroll: true });
    this.marquerVus();
  };

  Barre.prototype.synchroniser = function () {
    if (!this.principal || !this.bouton) return;
    if (!this.formatsVus) {
      this.bouton.disabled = false;
      this.bouton.textContent = this.libelleFormats;
      return;
    }
    var indisponible = this.principal.hasAttribute('disabled');
    this.bouton.disabled = indisponible;
    var texte = this.principal.querySelector('span');
    if (texte) this.bouton.textContent = texte.textContent.trim();
  };

  function initialiserBarres() {
    document.querySelectorAll('[data-s-barre]').forEach(function (element) {
      if (element.dataset.sPret) return;
      element.dataset.sPret = '1';
      barres.push(new Barre(element));
    });
  }

  /* 5. Avis Judge.me en français ------------------------------------------- */
  /* Titre, note moyenne (« 4.85 sur 5 »), « Sort by » et textes lus par les
     lecteurs d'écran. Le widget se redessine après un tri ou un changement de
     page : un observateur repasse sur les nouveaux éléments. */
  var ESPACE_INSECABLE = '\u00a0';

  function nombreAvis(n) {
    var valeur = parseFloat(n);
    return isNaN(valeur) ? n : valeur.toLocaleString('fr-FR', { maximumFractionDigits: 2 });
  }

  function etoiles(n) {
    return n + (n === '1' ? ' étoile' : ' étoiles');
  }

  var AVIS_TEXTES = [
    ['.jdgm-rev-widg__title', /^Avis Clients$/, function () { return 'Avis clients'; }],
    ['.jdgm-rev-widg__summary-average', /^([\d.]+) sur 5$/, function (m, n) { return nombreAvis(n) + ' sur 5'; }],
    ['.jdgm-sort-dropdown-label', /^Sort by$/, function () { return 'Trier par'; }],
    ['.jdgm-write-rev-link', /^Write a review$/, function () { return 'Écrire un avis'; }]
  ];

  var AVIS_ATTRIBUTS = [
    [/^Average rating is ([\d.]+) stars?$/, function (m, n) {
      return 'Note moyenne' + ESPACE_INSECABLE + ': ' + nombreAvis(n) + ' sur 5';
    }],
    [/^([\d.]+)% \((\d+)\) reviews? with (\d) stars? rating$/, function (m, p, n, e) {
      return nombreAvis(p) + ESPACE_INSECABLE + '% des avis (' + n + ') à ' + etoiles(e);
    }],
    [/^(\d) stars? review$/, function (m, e) { return 'Avis à ' + etoiles(e); }],
    [/^(.+) review photo(?: (\d+))?$/, function (m, nom, n) {
      return 'Photo' + (n ? ' ' + n : '') + ' de l’avis de ' + nom;
    }],
    [/^Verified Checkmark$/, function () { return 'Avis vérifié'; }]
  ];

  function franciserAvis(widget) {
    AVIS_TEXTES.forEach(function (regle) {
      widget.querySelectorAll(regle[0]).forEach(function (element) {
        if (element.children.length) return;
        var texte = element.textContent.trim();
        if (regle[1].test(texte)) element.textContent = texte.replace(regle[1], regle[2]);
      });
    });
    widget.querySelectorAll('[aria-label], img[alt]').forEach(function (element) {
      ['aria-label', 'alt'].forEach(function (nom) {
        var valeur = element.getAttribute(nom);
        if (!valeur) return;
        AVIS_ATTRIBUTS.some(function (regle) {
          if (!regle[0].test(valeur)) return false;
          element.setAttribute(nom, valeur.replace(regle[0], regle[1]));
          return true;
        });
      });
    });
  }

  function initialiserAvis() {
    document.querySelectorAll('.jdgm-widget').forEach(function (widget) {
      franciserAvis(widget);
      if (widget.dataset.sAvis || !('MutationObserver' in window)) return;
      widget.dataset.sAvis = '1';
      var prevu = false;
      new MutationObserver(function () {
        if (prevu) return;
        prevu = true;
        window.requestAnimationFrame(function () {
          prevu = false;
          franciserAvis(widget);
        });
      }).observe(widget, { childList: true, subtree: true });
    });
  }

  /* 6. Contenus numériques : accord exprès avant l'ajout au panier --------- */
  /* Le formulaire d'achat de Sense est en novalidate : la case « contenu numérique »
     (snippets/sesames-product-achat.liquid) est contrôlée ici, en phase de capture,
     avant product-form.js. Sans accord, rien n'est ajouté et la case est signalée
     (la barre d'achat collante passe aussi par ce contrôle). */
  function caseNonCochee(formulaire) {
    var cases = formulaire.querySelectorAll('[data-s-consentement]');
    for (var i = 0; i < cases.length; i++) {
      if (!cases[i].disabled && !cases[i].checked) return cases[i];
    }
    return null;
  }

  document.addEventListener('submit', function (evenement) {
    var formulaire = evenement.target;
    if (!formulaire || formulaire.getAttribute('data-type') !== 'add-to-cart-form') return;
    var manquante = caseNonCochee(formulaire);
    if (!manquante) return;
    evenement.preventDefault();
    evenement.stopImmediatePropagation();
    var bloc = manquante.closest('.s-consentement');
    var erreur = bloc && bloc.querySelector('.s-consentement__erreur');
    if (bloc) bloc.classList.add('s-consentement--erreur');
    if (erreur) erreur.hidden = false;
    manquante.setAttribute('aria-invalid', 'true');
    (bloc || manquante).scrollIntoView({ behavior: mouvementReduit.matches ? 'auto' : 'smooth', block: 'center' });
    manquante.focus({ preventScroll: true });
  }, true);

  document.addEventListener('change', function (evenement) {
    var champ = evenement.target;
    if (!champ || !champ.matches || !champ.matches('[data-s-consentement]') || !champ.checked) return;
    champ.removeAttribute('aria-invalid');
    var bloc = champ.closest('.s-consentement');
    if (!bloc) return;
    bloc.classList.remove('s-consentement--erreur');
    var erreur = bloc.querySelector('.s-consentement__erreur');
    if (erreur) erreur.hidden = true;
  });

  /* 7. « Envoyer à un·e collègue » : lien suivi --------------------------- */
  /* Le bloc de partage de Sense (snippets/share-button.liquid, assets/share.js) partage l'adresse de la fiche ;
     global.js la remplace à chaque changement de format. Ici, le lien partagé devient l'adresse de la fiche
     avec les paramètres de suivi, avant ou après l'initialisation du composant. */
  function lienPartage() {
    document.querySelectorAll('.s-produit share-button[id^="Share-"]').forEach(function (partage) {
      var section = partage.id.replace(/^Share-/, '');
      var infos = document.getElementById('ProductInfo-' + section);
      var adresse = infos && infos.dataset.url;
      if (!adresse) return;
      var handle = adresse.split('?')[0].split('/').filter(Boolean).pop() || '';
      var lien = (window.shopUrl || window.location.origin) + adresse.split('?')[0] +
        '?utm_source=partage&utm_medium=collegue&utm_campaign=' + encodeURIComponent(handle);
      var champ = partage.querySelector('input');
      if (champ) champ.value = lien;
      if (typeof partage.updateUrl === 'function') partage.updateUrl(lien);
      else partage.urlToShare = lien;
    });
  }

  /* Démarrage ------------------------------------------------------------ */
  function demarrer() {
    initialiserDetails();
    initialiserBarres();
    initialiserAvis();
    lienPartage();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, surChangementDeFormat);
    }
    if (window.location.hash && window.location.hash.indexOf('#s-panneau-') === 0) {
      ouvrirPanneau(window.location.hash.slice(1));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  /* Éditeur de thème : la section peut être rechargée */
  document.addEventListener('shopify:section:load', function () {
    initialiserDetails();
    initialiserBarres();
    initialiserAvis();
    lienPartage();
  });
})();
